
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { separateDigits, convertToPersian } from "@/utils/string";
import AppLoading from "@/components/UI/AppLoading.vue";
import ProductCard from "@/components/landing/products/ProductCard.vue";
import AppWarning from "@/components/UI/AppWarning.vue";

export default Vue.extend({
  name: "AdminAllProducts",
  data() {
    return {
      selectedCategory: null,
    };
  },
  components: {
    AppLoading,
    ProductCard,
    AppWarning,
  },
  computed: {
    categories(): string[] {
      const categories = store.state.panel.categories;

      let items: any[] = [];

      categories.forEach((category: any) => {
        const item = {
          title: `${category.title}: ${this.pathStyle(category.parentPath)}`,
          value: category["_id"],
        };
        items.push(item);
      });

      return items;
    },
    products(): any[] {
      return store.state.admin.adminProducts || [];
    },
  },
  methods: {
    separateDigits,
    convertToPersian,
    pathStyle(text: string): string {
      return text.split("/").splice(1).join(" > ");
    },
    getProducts(id: any): void {
      setTimeout(function () {
        store.dispatch("admin/getProducts", id);
      }, 2000);
    },
    addProduct(): void {
      router.push({
        name: "admin-add-product",
        query: { id: this.selectedCategory },
      });
    },
    editProduct(id: string): void {
      router.push({
        name: "admin-edit-product",
        query: { id: id },
      });
    },
    deleteProduct(id: string): void {
      store.dispatch("admin/deleteProduct", id);
    },
  },
  watch: {
    selectedCategory(newVal) {
      this.getProducts(newVal);
    },
  },
});
